var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "month-report-wrap" },
    [
      _c(
        "handleIcon",
        {
          attrs: { isAllScreen: _vm.isAllScreen },
          on: {
            allScreen: function ($event) {
              return _vm.toggleAllScreenFull(!_vm.isAllScreen)
            },
          },
        },
        [
          _c("template", { slot: "menu" }, [
            _c(
              "li",
              {
                on: {
                  click: function () {
                    return _vm.getAllData()
                  },
                },
              },
              [
                _c("div", { staticClass: "icon" }, [
                  _c("i", { staticClass: "iconfont iconRefresh" }),
                ]),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("dashboard-bi::default-board::refresh"))
                  ),
                ]),
              ]
            ),
          ]),
        ],
        2
      ),
      _c(
        "el-row",
        { staticClass: "card-content" },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("cardReport", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading.cardOptions,
                    expression: "loading.cardOptions",
                  },
                ],
                attrs: { cardData: { cardItems: _vm.cardOptions } },
                on: { toSetting: _vm.outTimeSet },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            [
              _c("label", { staticClass: "label-item" }, [
                _vm._v(
                  _vm._s(_vm.$t("operate-analysis::month-report::shop_name"))
                ),
              ]),
              _c(
                "el-select",
                {
                  staticClass: "search-item",
                  attrs: {
                    placeholder: _vm.$t("system::common::select_placeholder"),
                    popperAppendToBody: false,
                    filterable: "",
                  },
                  on: { change: _vm.changeShop },
                  model: {
                    value: _vm.params.shopId,
                    callback: function ($$v) {
                      _vm.$set(_vm.params, "shopId", $$v)
                    },
                    expression: "params.shopId",
                  },
                },
                _vm._l(_vm.shopList, function (item) {
                  return _c("el-option", {
                    key: item.shopId,
                    attrs: { label: item.shopName, value: item.shopId },
                  })
                }),
                1
              ),
              _c("label", { staticClass: "label-item" }, [
                _vm._v(_vm._s(_vm.$t("ocean-bi:订单支付日期"))),
              ]),
              _c("el-date-picker", {
                attrs: {
                  appendToBody: false,
                  clearable: false,
                  type: "daterange",
                  "unlink-panels": "",
                  "range-separator": _vm.$t("system::time::text::include"),
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  "picker-options": _vm.pickerOptions,
                },
                on: { change: _vm.handlerDateChange },
                model: {
                  value: _vm.date,
                  callback: function ($$v) {
                    _vm.date = $$v
                  },
                  expression: "date",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 16 } },
        [
          _c(
            "el-col",
            {
              staticStyle: { "margin-top": "18px" },
              attrs: { lg: 4, md: 24, sm: 24, xl: 4 },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                _vm._l(_vm.logisticsCardOptions, function (item, index) {
                  return _c(
                    "el-col",
                    {
                      key: index,
                      staticClass: "card-item",
                      attrs: { lg: 24, md: 8, sm: 8, xl: 24 },
                    },
                    [
                      _c("dataCard", {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading.logistics,
                            expression: "loading.logistics",
                          },
                        ],
                        staticClass: "my-data-card",
                        attrs: { option: item },
                      }),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { lg: 10, md: 24, sm: 24, xl: 10 } },
            [
              _c("reportCard", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading.deliver,
                    expression: "loading.deliver",
                  },
                ],
                style: "height: " + _vm.reportHeight + ";",
                attrs: { config: _vm.deliverConfig },
                on: { btns: _vm.onReportBtns },
              }),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { lg: 10, md: 24, sm: 24, xl: 10 } },
            [
              _c("reportCard", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading.perform,
                    expression: "loading.perform",
                  },
                ],
                style: "height: " + _vm.reportHeight + ";",
                attrs: { config: _vm.performConfig },
                on: { btns: _vm.onReportBtns },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 16 } },
        [
          _c(
            "el-col",
            {
              staticClass: "order-detail",
              staticStyle: { "margin-top": "18px" },
              attrs: { span: 24 },
            },
            [
              _c(
                "el-card",
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("operate-analysis::order-analysis::订单详情")
                        ) +
                        " "
                    ),
                  ]),
                  _c("z-table", {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading.detail,
                        expression: "loading.detail",
                      },
                    ],
                    ref: "table",
                    attrs: {
                      columns: _vm.columns,
                      data: _vm.orderDetailList,
                      height: 480,
                      pagination: _vm.pagination,
                    },
                    on: {
                      "update:pagination": function ($event) {
                        _vm.pagination = $event
                      },
                      "page-change": _vm.handlePageChange,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "product",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "div",
                              {
                                staticStyle: { position: "relative" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                              },
                              [
                                _vm._v(" " + _vm._s(row.product) + " "),
                                _c("GoodsPopover", {
                                  staticStyle: { display: "inline-block" },
                                  attrs: { row: row, config: _vm.params },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "grandTotalUsd",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$dataCheck(
                                    _vm.formatNumberMix(
                                      row.grandTotalUsd,
                                      2,
                                      ","
                                    )
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("setting-dialog", {
        attrs: { drawRow: _vm.drawRow, form: _vm.form },
        on: { save: _vm.onSave },
        model: {
          value: _vm.showDialog,
          callback: function ($$v) {
            _vm.showDialog = $$v
          },
          expression: "showDialog",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }